import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleProgressAnalysis = {
  namespaced: true,

  state: {
    name: 'progressAnalysis',
    progressAnalysis: []
  },

  mutations,
  getters,
  actions
}

export default moduleProgressAnalysis;